"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductList = void 0;
var _logger = require("@ori/logger");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _clsx = _interopRequireDefault(require("clsx"));
var _productListClasses = _interopRequireDefault(require("../../containers/ProductListContainer/productListClasses"));
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _Carousel = require("../Carousel/Carousel");
var _Counter = require("../Counter");
var _List = require("../List");
var _ListSkeleton = require("../ListSkeleton");
var _Pagination = require("../Pagination/Pagination");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ProductList = () => {
  const logger = (0, _logger.useLogger)('List');
  const {
    className,
    FooterComponent,
    HeaderComponent,
    isRefreshing,
    renderItemSkeleton,
    renderItemComponent,
    renderListSkeleton,
    shouldRenderItemCount,
    shouldRenderPagination,
    items
  } = (0, _contexts.useProductList)();
  const {
    mode,
    carousel
  } = (0, _hooks.useGetProductListMode)();
  const rootClassName = (0, _clsx.default)(_productListClasses.default.root, className);
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (mode === 'CAROUSEL') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CarouselRoot, {
      className: rootClassName,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Carousel.Carousel, {
        carousel: carousel,
        items: items,
        isRefreshing: isRefreshing,
        renderItemComponent: renderItemComponent,
        renderItemSkeleton: renderItemSkeleton
      })
    });
  }
  if (isRefreshing) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListSkeleton.ListSkeleton, {
      shouldRenderItemCount: shouldRenderItemCount,
      shouldRenderPagination: shouldRenderPagination,
      renderItemSkeleton: renderItemSkeleton,
      renderListSkeleton: renderListSkeleton
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: rootClassName,
    "data-testid": getTestId(_constants.PRODUCT_LIST),
    children: [HeaderComponent ?? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Counter.Counter, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
      logger: logger,
      fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListSkeleton.ListSkeleton, {
        shouldRenderItemCount: false,
        shouldRenderPagination: false,
        renderItemSkeleton: renderItemSkeleton,
        renderListSkeleton: renderListSkeleton
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List, {})
    }), FooterComponent ?? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Pagination.Pagination, {})]
  });
};
exports.ProductList = ProductList;
//# sourceMappingURL=ProductList.js.map